import { useSelector } from 'react-redux';
import { hasUserPermissions } from '../../helpers/utils/permissoes';

export const PERMISSAO_CONSULTAR_CLIENTE = 501;
export const PERMISSAO_EDITAR_CLIENTE = 504;

/**
 * Gate do botão "Consultar Cliente" da aba Cliente (AW2-1136 Etapa 4) —
 * mesma condição já checada em produção (`DadosCliente.jsx`,
 * `hasUserPermissions(501, 504)`, semântica OU — Consultar OU Editar já
 * habilita).
 *
 * Mesmo padrão de `usePodeGerenciarDevedor.js`/`usePodePesquisarWebServiceDevedor.js`
 * — hook reativo via `useSelector`, não `useMemo(..., [])` como a produção
 * real, para não travar no snapshot da 1ª renderização caso a permissão do
 * usuário logado mude durante a sessão.
 *
 * Gate apenas cosmético — a autorização real está na rota de destino
 * (`RoutesCliente.jsx`, já protegida por role) e no backend.
 */
export default function usePodeConsultarOuEditarCliente() {
  useSelector(state => state.authentication.userInformation.permissoes);
  return hasUserPermissions(PERMISSAO_CONSULTAR_CLIENTE, PERMISSAO_EDITAR_CLIENTE);
}
